import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';

const AgingBucketChart = ({ data, loading }) => {
    // Transform API data to chart format
    const chartData = data && data.buckets 
        ? data.buckets.map(bucket => ({
            name: bucket.label,
            value: bucket.count,
            color: bucket.bucket_id === '0-3' ? '#86EFAC' :
                   bucket.bucket_id === '4-7' ? '#FCD34D' :
                   bucket.bucket_id === '8-14' ? '#FDBA74' : '#FCA5A5',
            label: bucket.description
        }))
        : [
            { name: '0-3 days', value: 0, color: '#86EFAC', label: 'Fresh Claims' },
            { name: '4-7 days', value: 0, color: '#FCD34D', label: 'Moderate Claims' },
            { name: '8-14 days', value: 0, color: '#FDBA74', label: 'Delayed' },
            { name: '>15 days', value: 0, color: '#FCA5A5', label: 'Stale' },
        ];

    const CustomLegend = () => {
        return (
            <div className="flex flex-col gap-2 ml-4 justify-center">
                {chartData.map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                        <div className="w-8 h-4 border border-black" style={{ backgroundColor: item.color }}></div>
                        <span className="text-xs font-medium text-gray-700">{item.label}</span>
                    </div>
                ))}
            </div>
        );
    };

    if (loading) {
        return (
            <div className="h-full flex flex-col items-center justify-center">
                <h2 className="text-xl font-bold text-gray-900 mb-1">Aging Bucket</h2>
                <p className="text-sm text-gray-500 mb-6 font-medium">Claims Distribution by Aging Buckets</p>
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }
    return (
        <div className="h-full flex flex-col items-center w-full">
            <h2 className="text-xl font-bold text-gray-900 mb-1">Aging Bucket</h2>
            <p className="text-sm text-gray-500 mb-6 font-medium">Claims Distribution by Aging Buckets</p>
            <div className="w-full h-[300px] flex">
                <div className="flex-grow h-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={chartData}
                            margin={{
                                top: 20,
                                right: 10,
                                left: 0,
                                bottom: 20,
                            }}
                            barSize={50}
                        >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                            <XAxis
                                dataKey="name"
                                tick={{ fontSize: 10, fill: '#374151' }}
                                axisLine={true}
                                tickLine={false}
                                dy={10}
                                label={{ value: 'Aging Buckets (Days)', position: 'insideBottom', offset: -15, fontSize: 11 }}
                            />
                            <YAxis
                                domain={[0, 45]}
                                tick={{ fontSize: 10, fill: '#374151' }}
                                axisLine={true}
                                tickLine={false}
                                label={{
                                    value: 'Number of Claims',
                                    angle: -90,
                                    position: 'insideLeft',
                                    style: { textAnchor: 'middle', fontSize: '11px', fill: '#6B7280' },
                                    dx: 0
                                }}
                            />
                            <Tooltip cursor={{ fill: 'transparent' }} />
                            <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                                <LabelList
                                    dataKey="value"
                                    position="top"
                                    style={{ fill: '#374151', fontSize: '11px', fontWeight: 500 }}
                                    offset={5}
                                />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                {/* Custom Legend to match image exactly (Right side) */}
                <CustomLegend />
            </div>
        </div>
    );
};

export default AgingBucketChart;
